import './PriceTag.css';
import { UiContainer } from '../../state/ui';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { ApiProduct } from '../../types';
import { useConfig } from '../../config';
import { ProductContainer } from '../../state/product';
import { ProductUnits } from '../../i18n/sv';
import { calculateVatMultiplier } from '../../utils/vatUtils';

export const PriceTag = ({ product }: { product: ApiProduct }) => {
	const ui = UiContainer.useContainer();
	const { asPrice, asCurrency } = useFormatting();
	const { currency, currencyCode } = useConfig();
	const t = {
		...useTranslation().generic,
		...useTranslation().product,
	};
	const { id, price, campaignPrice, unit, vatRate } = product;
	const vatScale = calculateVatMultiplier(vatRate, ui.priceWithVat);
	const { getFinalPrice } = ProductContainer.useContainer();
	return (
		<div className="price-tag">
			<strong className={'price' + (campaignPrice > 0 ? ' campaign' : '')}>
				{currencyCode === 'EUR'
					? asPrice(getFinalPrice(id, price, 1, campaignPrice) * vatScale, 2)
					: asCurrency(getFinalPrice(id, price, 1, campaignPrice) * vatScale, 2)}
				<span className="unit">
					{currencyCode === 'EUR' ? '' : currency}/{t.units[unit as keyof ProductUnits]}
				</span>
			</strong>
			<span className="vat">{ui.priceWithVat ? t.incVat : t.exVat}</span>
		</div>
	);
};
